<div class="myPurchase-dialog-container">
  <div class="myPurchase-dialog-header">
    {{ input.headerTitle }}
    <button mat-button class="closeBtn" (click)="close()" *ngIf="input.isForm">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="myPurchase-dialog-content">
    <p *ngIf="!input.isForm">{{ input.contentMsg }}</p>
    <div class="formDiv" *ngIf="input.isForm">
      <form [formGroup]="input.formControl">
        <div class="form-inputs">
          <mat-label>Keyword search</mat-label>
          <input matInput formControlName="query" placeholder="Enter vendor name or status" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Country</mat-label>
          <ng-select formControlName="country" bindLabel="value" [items]="countryDp" placeholder="Select an Option"
            appearance="outline" />
        </div>
        <div class="form-inputs">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" placeholder="e.g Singapore" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Vendor type</mat-label>
          <ng-select formControlName="vendorType" bindLabel="Name" [items]="vendorTypeDp" placeholder="Select an Option"
            appearance="outline" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Vendor status</mat-label>
          <ng-select formControlName="vendorStatus" bindLabel="Name" [items]="vendorStatusDp"
            placeholder="Select an Option" appearance="outline" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Material Group</mat-label>
          <ng-select formControlName="mainMaterialGroup" bindLabel="value" [items]="materialGroupDp"
            (change)="onMaterialGroupChange($event)" placeholder="Select an Option" appearance="outline" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Material sub group</mat-label>
          <ng-select formControlName="materialGroup" bindLabel="value" [items]="materialSubGroupDp"
            placeholder="Select an Option" appearance="outline" />
        </div>
        <div class="form-inputs form-dropdown">
          <mat-label>Brand</mat-label>
          <ng-select formControlName="brand" bindLabel="value" [items]="brandDp" placeholder="Select an Option"
            appearance="outline" />
        </div>
      </form>
      <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container *ngFor="let column of displayedCols">
        <ng-container matColumnDef="{{ column }}">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
      </ng-container>
    
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="toggleRow(element)">
            <mat-icon>{{ expandedElement === element ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
          </button>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->

      <!-- Expandable Row -->
      <!-- <tr mat-row *matRowDef="let row; columns: ['expandedRow']; when: expandedElement === row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedRow']" class="expanded-row">
        <td [attr.colspan]="displayedColumns.length">
          <mat-expansion-panel *ngIf="expandedElement === row">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Expanded Details for {{ row.name }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{ row.description }}</p>
          </mat-expansion-panel>
        </td>
      </tr>
    </table> -->
    </div>
  </div>
  <div class="myPurchase-dialog-actions">
    <div mat-dialog-actions>
      <app-button class="padBtn" type="basic" name="{{ input.btnNameTwo }}" (click)="input.clickTwo()"
        [ngStyle]="{ display: input.btnNameOne == '' ? 'none' : 'block' }" *ngIf="!input.isForm"></app-button>
      <app-button class="padBtn" type="basic" name="{{ input.btnNameTwo }}" (click)="input.clickTwo()"
        [ngStyle]="{ display: input.btnNameOne == '' ? 'none' : 'block' }" *ngIf="input.isForm"></app-button>
      <app-button  [ngClass]="{ ' delete-button': input.btnNameOne === 'Delete'}" class="padBtn actionBtn" type="flat-button" name="{{ input.btnNameOne }}" (click)="input.click()"
        [ngStyle]="{ display: input.btnNameTwo == '' ? 'none' : 'block' }"></app-button>
    </div>
  </div>
</div>